
import React from "react";
import { FishingRegulationsContainer } from "./fishing-regulations/FishingRegulationsContainer";

export const FishingRegulations = () => {
  return <FishingRegulationsContainer />;
};
